import { compose } from 'recompose';

import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';

export default compose(
  withRouter,
  withStyles({})
);
